// extracted by mini-css-extract-plugin
export default {"in":"search_in__1YN4Y"};